import { Component, OnInit, OnDestroy, ViewEncapsulation,HostListener, ElementRef, ViewChild, AfterViewInit, Renderer2 } from "@angular/core";
import { ActivatedRoute, ActivationStart, Router, RouterOutlet } from "@angular/router";
import { QualService } from "src/app/qual/service/qual.service";
import { InsightsService } from "src/app/shared/insights/service/insights.service";
import { HomeService } from "src/app/shared/services/home.service";
import { SidePanelService } from "src/app/shared/services/side-pannel/side-pannel.service";
import { SharedataService } from "src/app/shared/share/service/sharedata.service";
import {ReportService} from "../service/report.service";
import { TrackerService } from "../service/tracker.service";
import { MatDialog } from "@angular/material/dialog";
import { LoginService } from "src/app/services/login.service";
import { DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import { NotifierService } from "angular-notifier";
// import {bounceAnimation} from '@angular/angular-animations';

@Component({
  selector: "file-viewer",
  templateUrl: "./file-viewer.component.html",
  styleUrls: ["./file-viewer.component.scss"],
  animations: [
    // bounceAnimation(),
  ]
})
// encapsulation: ViewEncapsulation.None,
export class FileViewerComponent implements OnInit, OnDestroy, AfterViewInit {
  public matProgressPar: boolean = true;
  public isGoogleViewer: boolean = false;
  public uuid: string = "";
  public study_id:string = "";
  public loadingTwice:boolean = false
  @ViewChild('videoPlay') video:ElementRef;

  // @ViewChild('videoPlay') videoPlayer: any;
  @ViewChild('audioPlayer') audioPlayer: any;
  // @ViewChild(RouterOutlet) outlet: RouterOutlet;

  public videoAnalyzerSwitch:boolean = false;
  public videoAnalyzerSRC:any = "";
  public videoAnalyzerDetaisSRC:any = "";
  public gettingVideoDurationInterval;
  public isDocPopub:boolean = false;
  public isFileUrlRefreshed:boolean = true;
  public isVideoLanguageChanged:boolean = false;
  public isValumeChangeFiredTwice:boolean = false;
  public currentFileUrl:string = "";
  private isProgrammaticMuteChange = false; // Flag to track programmatic mute changes



  // @ViewChild('videoPlay') videoPlayer!: ElementRef<HTMLVideoElement>;

  isPlaying = false;
  isMuted = false;
  volume = 1;
  currentTime = 0;
  duration = 0;
  public isVideoHovered:boolean = false;
  public timeOut;
  

  initSub: any;
  

  constructor(
    public reportService: ReportService,
    private router: Router,
    private route: ActivatedRoute,
    public homeService: HomeService,
    public sidePanelService: SidePanelService,
    public QService: QualService,
    public iService: InsightsService,
    //private activaterRoute:ActivatedRoute, 
    public sService: SharedataService,
    public sanitizer:DomSanitizer,
    public trackerService:TrackerService,
    private loginService: LoginService, 
    private dialoge: MatDialog,
    public notifier:NotifierService,
    private readonly renderer: Renderer2
    ) {
      this.uuid = this.route.snapshot.params['uuid'];
      this.isDocPopub = false;
      // Reset side panel init flag for clean initialization
      this.reportService.resetSidePanelInitFlag();
      this.reportService.getRepositoryDetailByFile(this.uuid)
      // console.log("File Viewer Constructor studyId ===> ",this.reportService.studyId)
      // if (!(this.reportService.studyId && this.reportService.studyId !="")) {
      //   this.reportService.getRepositoryDetailByFile(this.uuid)
      // }else{
      //   this.sidePanelService.initSideDrawer('repo');
      // }
      
    //   if (
    //   this.router.url.includes("qual") &&
    //   (!this.reportService.fileURL || this.reportService.fileURL == "")
    // ) {
    //   this.router.navigate(["home/qual/report/", this.QService.studyId]);
    // } else if (
    //   !this.reportService.fileURL ||
    //   this.reportService.fileURL == ""
    //   ) {
    //     this.router.navigate([
    //       "home/repository-report/details/",
    //       this.QService.studyId,
    //     ]);
    //   } else {
    //   }
    //   if (this.router.url.includes("qual")) {
    //     this.homeService.isOpen = false;
    //   }
    this.initSub = this.reportService.initFileView
        .subscribe(()=> {
          this.initFileViewer();
        })
    }
    
    public interval: number = 0;
    public timer;
    startTimer(){
      this.stopTimer();
      this.timer = setInterval(() => {
        this.interval++;
      },1000);
    }
    stopTimer(){
      clearInterval(this.timer);
    }
    @HostListener('window:focus', ['$event'])
    onFocused(event) {
      if (this.reportService) {
        if(this.reportService.fileCategory == 'video' || this.reportService.fileCategory == 'audio' ){
          this.checkVideo('');
        }else{
          this.startTimer();
        }
      }
    }
    @HostListener('window:blur', ['$event'])
    onBlur(event) {
      if (this.reportService) {
        if(this.reportService.fileCategory == 'video' || this.reportService.fileCategory == 'audio' ){
          this.checkVideo('');
        }else{
          this.stopTimer();
        }
      }
    }
    @HostListener('window:beforeunload',['$event'])
    unload(event)
    {
      if(this.reportService.fileCategory == 'video' || this.reportService.fileCategory == 'audio' ){
        this.video.nativeElement.pause();
        this.checkVideo(event)
      }
            event.preventDefault();
            event.returnValue = false;
            this.loginService.isSessionLoggedOut().subscribe((result) => {
              if(result['message'] == 'success') {
                this.submitTracker();
              }
            })
    }

    
    // @HostListener('window:beforeunload', ["$event"]) 
    // unload(event) {
    //   clearInterval(this.timer);
    //   this.submitTracker();
    // }

  ngOnInit() {
    
    // this.router.events.subscribe(e => {
    //   if (e instanceof ActivationStart && e.snapshot.outlet === "administration")
    //     this.outlet.deactivate();
    // });
    // this.setupFile();
    // this.initFileViewer();
  }

  // setupFile() {
  //   if(this.router.url.includes('qual')) {
  //     this.reportService.openQualFile( {"uuid":this.uuid}).subscribe(result =>{
  //       if (result['status'] == 1) {
  //         // this.study_id = result['studyId'] || '5aa3104c-631d-4ca7-993c-8977cf17990f';
  //         this.study_id = result['studyId'];
  //         this.reportService.studyId = result['studyId'];
  //         this.reportService.isQual = true;
  //         this.initStudyData(result);
  //       }
  //     },error =>{
  //       this.reportService.isLoading = false;
  //     })
  //   } else {
  //     this.reportService.openFile({"uuid":this.uuid}).subscribe(result =>{
  //       // this.openFile({"uuid":this.fileUUID}).subscribe(result =>{
  //       if (result['status'] == 1) {
  //         // this.study_id = result['studyId'] || '5aa3104c-631d-4ca7-993c-8977cf17990f';
  //         this.reportService.studyId = result['studyId'];
  //         this.study_id = result['studyId'];
  //         this.reportService.isQual = false;
  //         this.initStudyData(result);
  //       }
  //     },error =>{
  //       this.reportService.isLoading = false;
  //     })
  //   }
  // }

  // initStudyData(result1) {
  //   result1['uuid'] = this.uuid;
  //   this.reportService.getRepositoryDetail(this.study_id,{fileView:'file-view',getFileResult:result1,fileUUID:this.uuid});
  // }

  initFileViewer(){
    // console.log("File Viewer initFileViewer studyId ===> ",this.reportService.studyId)
    if(this.reportService.fileCategory == 'video' || this.reportService.fileCategory == 'audio' ){
      this.calculateCurrentMediaDuration();
      this.matProgressPar = false;
    }
    if(this.reportService.fileCategory == 'image'){
      this.matProgressPar = false;
      // this.stopTimer();
      this.startTimer();
    }
    if(this.reportService.fileType && (this.reportService.fileType.includes('pdf') || this.reportService.fileType.includes('csv') || this.reportService.fileType.includes('presentation'))){
      this.isGoogleViewer = true;
      this.reportService.fileURL = encodeURIComponent(this.reportService.fileURL);
      this.loadingTwice = false;
      this.loadingPopup();
    }
    // Handle unsupported file types - dismiss popup quickly since we show manual message
    if (this.isUnsupportedFileType()) {
      this.matProgressPar = false;
      this.CloseDialoge();
    } else if (!this.isGoogleViewer && this.reportService.fileCategory == 'application') {
      this.loadingPopup();
      setTimeout(() => {
        this.CloseDialoge();
        // this.matProgressPar = false;
      }, 10000);
    }
    setTimeout(() => {
      this.reportService.isLoading = false;
      if (this.reportService.fileCategory != 'video' && this.reportService.fileCategory != 'audio' && this.reportService.fileCategory != 'image') {
        this.startTimer();
      }
      
    }, 500);
    this.iService.getInsightList({"uuid":this.uuid,"type":"file"});
    this.reportService.checkVocAccess();
    this.reportService.checkSignTestUserLevelAccess();
  }

  ngAfterViewInit(): void {
    // this.video.nativeElement.onplay = () => {
    //   this.audioPlayer.nativeElement.play();
    // };

    // this.video.nativeElement.onpause = () => {
    //   this.audioPlayer.nativeElement.pause();
    // };

    // this.video.nativeElement.onseeked = () => {
    //   this.audioPlayer.nativeElement.currentTime = this.video.nativeElement.currentTime;
    // };

    // this.audioPlayer.nativeElement.onplay = () => {
    //   this.video.nativeElement.play();
    // };
  
   
  }

  
  ngOnDestroy(){
    this.stopTimer();
    this.loginService.isSessionLoggedOut().subscribe((result) => {
      if(result['message'] == 'success') {
        this.submitTracker();
      }
    })
    // this.submitTracker();
    this.pauseVideo('pause');
    this.reportService.summaryInnerHtml = ""
    this.reportService.summarySafeInnerHtml = ""
    this.iService.close();
    this.sService.close();
    this.iService.VOCList = null;
    this.iService.VOCsToBeClub = null;
    this.reportService.isInvalidTranscript = false
    if(this.initSub) this.initSub.unsubscribe();
  }

  calculateCurrentMediaDuration(){
    this.gettingVideoDurationInterval = setInterval(()=>{
      if(this.video){
        if(!isNaN(this.iService.video_duration)){
          clearInterval(this.gettingVideoDurationInterval);
        }
        else{
          this.iService.video_duration=this.video.nativeElement.duration;
        }
      }
    },500);
  }

  loadingPopup(){
    this.isDocPopub = true;
  }

  downloadRequest(type?: string) {
    let Ahref: HTMLElement = document.getElementById("downloadFIleURL");
    this.reportService.ahref = Ahref;
    if (type === 'pdf' || type === 'word') {
      this.reportService.downloadICVTranscript(type);
    }else{
      this.reportService.downloadRequestFromService(type);
    }
    
  }

  breadcrumbClick(index) {
    switch (index) {
      case 1:
        if (this.reportService.isQual) {
          this.router.navigate(["qual/report/", this.reportService.studyId]);
          // this.router.navigate(["home/qual/report/", this.reportService.studyId]);
        } else {
          this.router.navigate(["repo/details/",this.reportService.studyId]);
          // this.router.navigate(["home/repository-report/details/",this.reportService.studyId]);
        }
        break;

      case 2:
        if (this.reportService.isQual) {
          this.router.navigate(["qual/interview/", this.reportService.studyId]);
          // this.router.navigate(["home/qual/interview/", this.reportService.studyId]);
        } else {
          this.router.navigate(["repo"]);
          // this.router.navigate(["home/repository-report"]);
        }
        break;
    }
  }

  contentLoaded(event) {
    // let isChrome = window.navigator.userAgent.toLowerCase().includes('chrome');
    // if (isChrome) {
    //   this.loadingTwice = !this.loadingTwice
    //   this.matProgressPar = this.loadingTwice;
    //   setTimeout(()=>{
    //     if (this.loadingTwice) {
    //       this.loadingTwice = false;
    //       this.matProgressPar = this.loadingTwice;
    //       if(this.reportService.fileType && (this.reportService.fileType.includes('pdf') || this.reportService.fileType.includes('document') || this.reportService.fileType.includes('csv') || this.reportService.fileType.includes('sheet'))){
    //         this.isGoogleViewer = true;
    //       }else{
    //         this.reportService.isFileFound = false;
    //         this.isGoogleViewer = false;
    //         setTimeout(() =>{
    //           this.reportService.isFileFound = true;
    //         },100)
    //       }
    //     }
    //     this.CloseDialoge();
    //   },10000)
    // }else{
    //   this.matProgressPar = false;
    //   this.CloseDialoge();
    // }
    // this.matProgressPar = false;
    if(this.loadingTwice) {
      this.CloseDialoge();
    } else this.loadingTwice = true;
  }

  CloseDialoge = () =>
    {
      this.isDocPopub = false;
      this.matProgressPar = false;
      this.dialoge.closeAll();
      
    }

  showCommentPanel() {
    this.iService.openInsight(this.reportService.fileUUID, "file", "");
  }
  showSharePanel() {
     if(this.sidePanelService.isGuestAccount){
      this.notifier.notify('warning', this.sidePanelService.genericAccountNotification);
    }else{
      this.sService.openSharePanel(this.uuid, "file");
    }
  }

  // downloadFile(url) {
  //   let ahref: HTMLElement = document.getElementById("downloadFIleURL");
  //   const data = url;
  //   ahref.setAttribute("href", url);
  //   ahref.setAttribute("target", "_blank");
  //   ahref.setAttribute(
  //     "download",
  //     this.reportService.fileName + "." + this.reportService.fileType
  //   );
  //   ahref.click();
  // }

  showVOCPanel(){
    if(this.sidePanelService.isGuestAccount){
      this.notifier.notify('warning', this.sidePanelService.genericAccountNotification);
    }else{
      if(this.reportService.fileCategory == 'video' || this.reportService.fileCategory == 'audio'){
        this.iService.openVOC(this.reportService.fileUUID,'file');
      }
      else{
        this.iService.openVOC(this.QService.studyId,'study');
      }
    }
  }

  pauseVideo(event){
    if (this.video && this.video.nativeElement) {
      if (event == 'play') {
        this.video.nativeElement.play();
      }else{
        this.video.nativeElement.pause();
      }
    }
  }

  
  VideoAnalyzerOn = () =>
  {
    if(this.sidePanelService.isGuestAccount){
      this.notifier.notify('warning', this.sidePanelService.genericAccountNotification);
    }else{
      if(this.videoAnalyzerSwitch === false)
      {
        this.reportService.getVideoAnalyzerUUID();
        this.MakeUrlForIframe(1);
        this.MakeUrlForIframe(2);
      }
      setTimeout(() => {
        this.videoAnalyzerSwitch = !this.videoAnalyzerSwitch;
      },1000)
    }

  }
  
  trustedUrlMakers = (video:string) =>
  {
    //return this.sanitizer.bypassSecurityTrustUrl(video);
    return this.sanitizer.bypassSecurityTrustResourceUrl(video)
  }
  MakeUrlForIframe = (n:number) =>
  {
    if(n == 1)
    {
      var video = `https://www.videoindexer.ai/embed/player/${this.reportService.videoTokenDetails['account_id']}/${this.reportService.videoTokenDetails['video_id']}/?autoplay=false&accessToken=${this.reportService.videoTokenDetails['access_token']}`;
      // return this.trustedUrlMakers(video);
      this.videoAnalyzerSRC = this.trustedUrlMakers(video);
    }
    else 
    {
      var video = `https://www.videoindexer.ai/embed/insights/${this.reportService.videoTokenDetails['account_id']}/${this.reportService.videoTokenDetails['video_id']}/?preset=all&accessToken=${this.reportService.videoTokenDetails['access_token']}`;
      // return this.trustedUrlMakers(video);
      this.videoAnalyzerDetaisSRC = this.trustedUrlMakers(video);
    }
  }

  submitTracker(){
    // this.onBlur('')
    this.stopTimer();
    let data = {}
    data['uuid'] = this.reportService.fileUUID;
    data['file_type'] = 'repo';
    data['viewtime'] = this.interval;
    data['action'] = 'exit';
    data['session_id'] = this.reportService.trackerSessionId;
    // data['misc'] = {'action':'view'};
    if (data['uuid'] && data['uuid'] != '') {
      this.trackerService.submitTracker(data);
    }
  }

  checkVideo(event){
    this.stopTimer();
    if (this.video && this.video.nativeElement.paused) {
      this.stopTimer();
      this.onVideoPouseClick();
    }else{
      this.onVideoPlayClick();
      this.startTimer();
    }
  }

  onVideoPouseClick(){
    if (this.isVideoLanguageChanged) {
      const audio: HTMLAudioElement = this.audioPlayer.nativeElement;
      audio.pause();
    }
  }

  onVideoPlayClick(){
    if (this.isVideoLanguageChanged) {
      const video: HTMLVideoElement = this.video.nativeElement;
      const audio: HTMLAudioElement = this.audioPlayer.nativeElement;
      video.muted = true;
      audio.play();
    }
  }


getLanguageName(){
  this.currentFileUrl = this.currentFileUrl && this.currentFileUrl !== '' ? this.currentFileUrl : this.reportService.fileURL;
  let selectedLanguage = this.reportService.fileLanguages.find((item) => { return item.file_url === this.currentFileUrl})
  // let selectedLanguage = this.reportService.fileLanguages.find((item) => { return item.file_url === this.reportService.fileURL})
  return selectedLanguage ? selectedLanguage.language : '';
}

isUnsupportedFileType(): boolean {
  // List of file types that cannot be previewed and should only be downloaded
  const unsupportedTypes = ['zip', 'rar', '7z', 'tar', 'gz', 'bz2', 'exe', 'msi', 'dmg'];
  const fileName = this.reportService.fileName.toLowerCase();
  return unsupportedTypes.some(ext => fileName.endsWith('.' + ext));
}

// selectLanguage(languageObj){
//   this.isFileUrlRefreshed = false
//   this.reportService.fileURL = languageObj.file_url;
//   setTimeout(() => {
//     this.reportService.fileCategory == 'audio'
//     this.isFileUrlRefreshed = true;
//   }, 10);
  
// }

selectLanguage(languageObj){
  this.currentFileUrl = "";
  if (this.reportService.fileURL == languageObj.file_url) {
    this.isVideoLanguageChanged = false;
    this.currentFileUrl = languageObj.file_url;
    const video: HTMLVideoElement = this.video.nativeElement;
    const audio: HTMLAudioElement = this.audioPlayer.nativeElement;
    video.muted = false;
    audio.pause();
  }else{
    this.isVideoLanguageChanged = true;
    this.currentFileUrl = languageObj.file_url;
    const video: HTMLVideoElement = this.video.nativeElement;
    const audio: HTMLAudioElement = this.audioPlayer.nativeElement;
    const sources = audio.getElementsByTagName('source');
    // Dynamically set the 'src' attribute for both source elements
    Array.from(sources).forEach((source: any) => {
      this.renderer.setAttribute(source, 'src', this.currentFileUrl);
    });

    // Reload the audio element to apply the new source
    audio.load();
    this.audioPlayer.nativeElement.currentTime = this.video.nativeElement.currentTime;
    video.muted = true;
    this.checkVideo('');
    // this.isPlaying = true;
    // video.play();
    // audio.play();
  }
}

// onSeeked(event){
//   if (this.isVideoLanguageChanged) {
//     this.isVideoLanguageChanged = true;
//     const video: HTMLVideoElement = this.video.nativeElement;
//     const audio: HTMLAudioElement = this.audioPlayer.nativeElement;
//     this.audioPlayer.nativeElement.currentTime = this.video.nativeElement.currentTime;
//     video.muted = true;
//     if (!video.paused) {
//       audio.play();
//     }
//   }
// }

// onVolumeChange(event: Event): void {
//   if (this.isVideoLanguageChanged) {
//     const video: HTMLVideoElement = this.video.nativeElement;
//     const audio: HTMLAudioElement = this.audioPlayer.nativeElement;
  
//     if (this.isVideoLanguageChanged) {
//       if (video.muted) {
//         audio.muted = true;
//       } else {
//         audio.muted = false;
//       }
  
//       // Ensure the video remains muted programmatically
//       this.isProgrammaticMuteChange = true; // Set the flag
//       video.muted = true; // Programmatic mute
//     }
//   }
// }



onVideoEnded() {
  this.audioPlayer.nativeElement.currentTime = 0;
  this.video.nativeElement.currentTime = 0;
  this.audioPlayer.nativeElement.pause();
  this.video.nativeElement.pause();
  this.isPlaying = false;
}

togglePlay(): void {
  const video = this.video.nativeElement;
  if (video.paused) {
    video.play();
    this.isPlaying = true;
  } else {
    video.pause();
    this.isPlaying = false;
  }
  this.checkVideo('');
}

toggleMute(): void {
  const video = this.video.nativeElement;
  this.isMuted = !this.isMuted;
  video.muted = this.isMuted;
  if (this.isVideoLanguageChanged) {
    const audio: HTMLAudioElement = this.audioPlayer.nativeElement;
    audio.muted = this.isMuted;
  }
}

changeVolume(event: Event): void {
  const input = event.target as HTMLInputElement;
  this.volume = parseFloat(input.value);
  this.video.nativeElement.volume = this.volume;
}

updateProgress(): void {
  const video = this.video.nativeElement;
  this.currentTime = video.currentTime;
}
setDuration(): void {
  this.duration = this.video.nativeElement.duration;  
}

mediaPlaying(event){
  this.isPlaying = this.video && this.video.nativeElement && !this.video.nativeElement.paused ? true : false;
}
mediaDataLoaded(){
  this.isPlaying = this.video && this.video.nativeElement && !this.video.nativeElement.paused ? true : false;
}
seekVideo(event: Event): void {
  const input = event.target as HTMLInputElement;
  this.video.nativeElement.currentTime = parseFloat(input.value);
  if (this.isVideoLanguageChanged) {
    this.isVideoLanguageChanged = true;
    const video: HTMLVideoElement = this.video.nativeElement;
    const audio: HTMLAudioElement = this.audioPlayer.nativeElement;
    this.audioPlayer.nativeElement.currentTime = this.video.nativeElement.currentTime;
    video.muted = true;
    if (!video.paused) {
      audio.play();
    }
  }
}

formatTime(time: number): string {
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
}

     @HostListener('document:click', ['$event'])
     onClick(ev:MouseEvent){
        let classListArr = Array.from(ev.target['classList']);

        if(classListArr && classListArr.includes('video') && !classListArr.includes('lds-spinner')){
            this.togglePlay();
        }
     }

    @HostListener('document:mousemove', ['$event'])
    onMouseMove(ev:MouseEvent) {
      let classListArr = Array.from(ev.target['classList']);
      clearTimeout(this.timeOut);

      if(classListArr && classListArr.includes('hover')){
          this.isVideoHovered = true;
          if(classListArr.includes('video') || classListArr.includes('close-dialog')) this.timeOut = setTimeout(()=> {this.isVideoHovered = false;},3000);
      }
      else{
          this.isVideoHovered = false;
      }
     }
}
